import "../../../css/DesignSystem/Inputs/SearchField.css";
import { ReactComponent as SearchIcon } from "../../../assets/icons/search icon.svg";
import { ReactComponent as CloseIcon } from "../../../assets/icons/Close- new.svg";

const SearchField = ({
  id,
  label,
  value,
  onChange,
  placeholder = "Search",
  error = false,
  helperText,
  required = false,
  disabled = false,
  icon,
  OnSearch,
}) => {
  const inputId = id || `search-${label?.replace(/\s+/g, "-")?.toLowerCase()}`;

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && OnSearch) {
      e.preventDefault();
      OnSearch();
    }
  };

  return (
    <div className={`ds-input-field ${error ? "ds-input-field--error" : ""}`}>
      {label && (
        <label className="ds-input-label" htmlFor={inputId}>
          {label}
          {required && <span className="ds-input-required">*</span>}
        </label>
      )}
      <div className="ds-input-wrapper ds-input-wrapper--search">
        <input
          id={inputId}
          className="ds-input"
          type="search"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          onKeyPress={handleKeyPress}
        />
        <span
          className="ds-input-icon"
          onClick={OnSearch}
          style={{ cursor: "pointer" }}
        >
          <SearchIcon />
        </span>
      </div>
      {/* {helperText && (
        <div
          className={`ds-input-helper ${error ? "ds-input-helper--error" : ""}`}
        >
          {helperText}
        </div>
      )} */}
    </div>
  );
};

export default SearchField;
